import { createAppAuthClient } from "@repo/auth/client"

export const authClient = createAppAuthClient(
  import.meta.env.VITE_API_URL ?? "http://localhost:4000"
)

export const { useSession, signOut } = authClient
